export default {
    CURRENCIES: {
        DOLLAR: '$',
        EURO: '€',
    },
};



// WEBPACK FOOTER //
// ./src/lib/globalConstants.js